/**
 * localStorage keys of the sourcing module. `TABLE_*_PREFIX` keys get the table name appended,
 * `*_PREVIEW_LAYOUT_PREFIX` keys are expanded by `getPreviewLayoutStorageKeys`.
 */
export const sourcingStorageKey = {
  TABLE_SORTING_PREFIX: 'sourcing-table--sorting/',
  TABLE_REAL_TIME_PREFIX: 'sourcing-table--is-real-time/',
  FILTERS: 'sourcingFilters',
  FILTER_PRESET_ID: 'dms--sourcing-filter-preset-id',
  FILTER_PRESETS_EXPANDED: 'sourcing-filter-presets-expanded',
  PREVIEW_LAYOUT_PREFIX: 'sourcingPreview',
  DETAIL_PREVIEW_LAYOUT_PREFIX: 'sourcingDetailPreview',
} as const;
